<template>
<div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div
          @dragstart="beginDrag"
          @dragover.stop 
          class="card"
          :draggable="true"
          v-bind="attrs"
                v-on="on"
        >
          {{name}}
          
        </div>
      </template>
      <span>{{name}}</span>
    </v-tooltip>


</div>
</template>
<script>
export default {
  props:{
    id: {
      type: String,
      default: ''
    },
    name:{
      type: String,
      default: ''
    }
  },
  methods:{
    beginDrag(event) {
      event.dataTransfer.setData('id', this.id)
      event.dataTransfer.setData('name', this.name)
    },
  }
}
</script>
<style scoped>
.card{
  cursor:pointer;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  -o-user-select:none;
  user-select:none;
}
div.card{
  text-overflow: ellipsis!important;
  overflow: hidden!important;
  
}
.text-help{
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 3px;
  z-index: 2;
  font-size: 10px;
  left: 50px;
}
</style>